import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useNavigateToThemeOverview } from '~/hooks/use-navigate-to-theme-overview/useNavigateToThemeOverview';

import { MarketCatalystWidget } from './market-catalyst-widget/MarketCatalystWidget';
import * as S from './MarketCatalystDrawer.styles';
import { useMarketCatalystDrawer } from './useMarketCatalystDrawer';

export const MarketCatalystDrawer = () => {
  const { t } = useTranslation(['insights']);
  const { navigateToTheme } = useNavigateToThemeOverview();

  const { closeDrawer, isOpen, themeId, drawerType, insightId } =
    useMarketCatalystDrawer();

  const handleHeaderButtonClick = () => {
    if (themeId) {
      navigateToTheme({ themeId });
    }

    return null;
  };

  if (!isOpen) {
    return null;
  }

  return (
    <S.StyledDrawer
      data-testid="market-catalyst-drawer"
      isOpen={isOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        drawerType === 'thematic' ? (
          <Button
            variant="empty"
            label={t('insights:catalyst.viewOnTheme')}
            iconName="Expand"
            size="xsmall"
            onClick={handleHeaderButtonClick}
          />
        ) : (
          <span />
        )
      }
    >
      <S.ContentWrapper>
        <ErrorBoundaryWrapper>
          {!!insightId && <MarketCatalystWidget insightId={insightId} />}
        </ErrorBoundaryWrapper>
      </S.ContentWrapper>
    </S.StyledDrawer>
  );
};
